import { Component, OnInit, ViewChild, ChangeDetectorRef, Input } from '@angular/core';
import { Gtp } from 'src/app/shared/gtp';
import { ActivatedRoute } from '@angular/router';
import { ControlVelocidadService } from 'src/app/services/flota/control-velocidad-service/control-velocidad.service';

import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { PageEvent } from '@angular/material/paginator';

import {animate, state, style, transition, trigger} from '@angular/animations';
import { Subscription } from 'rxjs';

// import { ChartOptions, ChartType, ChartDataSets } from 'chart.js';
// import * as pluginDataLabels from 'chartjs-plugin-datalabels';
// import { Label } from 'ng2-charts';

@Component({
  selector: 'app-informe-hoja-ruta',
  templateUrl: './informe-hoja-ruta.component.html',
  styleUrls: ['./informe-hoja-ruta.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({height: '0px', minHeight: '0'})),
      state('expanded', style({height: '*'})),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class InformeHojaRutaComponent implements OnInit {

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort; 
  pageEvent: PageEvent;
  expandedElement = null;

  public contClass: string = 'container-fluid maincont';
  public filter: any = {
    desde : null,
    hasta : null,
    velocidad: 10,
    buscar: '',
    orderby: 'cod_vehiculo',
    sortby: 'asc',
    pageIndex: 0,
    pageSize: 10
  };
  public loading: boolean = false;  

  public dataSource: MatTableDataSource<any>;
  public distanciaTotal : any = 0;
  public odometroTotal : any = 0;
  public consumoTotal : any = 0;
  public tableCount;
  public tableDisplay: Boolean = true;
  public showLoading: Boolean = false;
  public loadingPdf: Boolean = false;
  public loadingXls: Boolean = false;

  filtroForm : Subscription;

  displayedColumns: string[] = [
    'equipoRastreo',
  ];

  /* Graphic */
  // public barChartOptions: ChartOptions = {
  //   responsive: true,
  //   // We use these empty structures as placeholders for dynamic theming.
  //   scales: { xAxes: [{}], yAxes: [{}] },
  //   plugins: {
  //     datalabels: {
  //       anchor: 'end',
  //       align: 'end',
  //     }
  //   }
  // };
  // public barChartLabels: Label[] = ['2006', '2007', '2008', '2009', '2010', '2011', '2012'];
  // public barChartType: ChartType = 'bar';
  // public barChartLegend = true;
  // public barChartPlugins = [pluginDataLabels];

  // public barChartData: ChartDataSets[] = [
  //   { data: [65, 59, 80, 81, 56, 55, 40], label: 'Series A' },
  //   { data: [28, 48, 40, 19, 86, 27, 90], label: 'Series B' }
  // ];
  /* Graphic */

  constructor(
    private gtp : Gtp,
    private route: ActivatedRoute,
    private velocidad: ControlVelocidadService,
    private cdRef:ChangeDetectorRef
  ) { 
    // this.filtroForm = this.velocidad.getFiltroForm().subscribe(msg => {      
    //   this.filter.desde = msg.desde;
    //   this.filter.hasta = msg.hasta;
    //   this.filter.velocidad = msg.velocidad;
    //   this.loadInforme();
    // });
    let fecha = this.gtp.DiaEntero();
    this.filter.desde = fecha.desde;
    this.filter.hasta = fecha.hasta;  
    this.loadInforme();
  }

  ngOnInit() {
    
    this.dataSource = new MatTableDataSource();
    this.dataSource.paginator = this.paginator;
    if(this.dataSource.data.length==0){
      this.tableDisplay = false;
    }

  }

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }

  ngAfterViewChecked() {
    this.cdRef.detectChanges();
  }

  ngOnDestroy() {
    // unsubscribe to ensure no memory leaks
    //this.filtroForm.unsubscribe();
  }

  loadInforme(){
    this.loading = true;
    this.velocidad.getControlVelocidadMoviles(this.filter).subscribe(res => {
      this.dataSource = new MatTableDataSource(res['rows']);
      this.tableCount = res['count'];
      this.dataSource.sort = this.sort;
      this.loading = false;
      this.tableDisplay = true;
    });
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  setSort(event?) {
    this.filter.orderby = event.active;
    this.filter.sortby = event.direction;
    this.loadInforme();
  }

  setPagination(event?) { 
    this.filter.pageIndex = parseInt(event.pageIndex);
    this.filter.pageSize = parseInt(event.pageSize);
    this.loadInforme();
    return event;
  }

  getPageSizeOptions(): number[] {    
    return [10, 20, this.tableCount];
  }

  /**
   * Cierra la ventana del informe activa.
   */
  cerrarInforme() {
    this.gtp.cerrarVentanas(true);    
  }

  /**
   * Aumenta o disminuye el tamaño del ancho en el informe.
   */
  containerSize() {
    this.contClass = this.gtp.containerSize(this.contClass);
  }

  exportPDF(){
    this.loadingPdf = true;
    var colores = this.gtp.tableColors;
    var data = [
      //Agregar Header
      [
        { text: 'Cod. Equipo', fillColor: colores.header, fontSize: 11, alignment: 'center' },
        { text: 'Descripción', fillColor: colores.header, fontSize: 11, alignment: 'center' },
        { text: 'Fecha', fillColor: colores.header, fontSize: 11, alignment: 'center' },
        { text: 'Hora', fillColor: colores.header, fontSize: 11, alignment: 'center' },
        { text: 'Dirección', fillColor: colores.header, fontSize: 11, alignment: 'center' },
        { text: 'Velocidad', fillColor: colores.header, fontSize: 11, alignment: 'center' },
        { text: 'Ver Mapa', fillColor: colores.header, fontSize: 11, link: '', alignment: 'center' },
      ]
    ];
    //Carga Registros
    let cont = 1;
    this.dataSource.data.forEach((e,i) => {
      if(e.mensajes.count!=0){          
        if(e.mensajes.count==0) { return; }
        e.mensajes.list.forEach((item,k) => {
          var bgcolor = (cont%2==0) ? colores.tdinterval : colores.td;
          data.push([
            { text: e.cod_equipo_rastreo, fillColor: bgcolor, fontSize: 10, alignment: 'center', },
            { text: e.equipoRastreo.des_equipo_ratreo, fillColor: bgcolor, fontSize: 10, alignment: 'center', },
            { text: this.gtp.getDay(item.fecha_hora), fillColor: bgcolor, fontSize: 10, alignment: 'center', },
            { text: this.gtp.getHour(item.fecha_hora), fillColor: bgcolor, fontSize: 10, alignment: 'center', },
            { text: item.direccion.formateada, fillColor: bgcolor, fontSize: 10, alignment: 'center', },
            { text: item.velocidad+' Km/h', fillColor: bgcolor, fontSize: 10, alignment: 'center', },
            { text: `Ver`, link:`https://maps.google.com/?q=${item.latitud},${item.longitud}`, fillColor: bgcolor, fontSize: 10, alignment: 'center', },
          ]);
          cont++;
        });
      }
    });      
    const pdfData = { 
      titulo: 'CONTROL DE VELOCIDADES',
      fecha: `Desde: ${this.filter.desde} - Hasta: ${this.filter.hasta}`,
      columnwidth: [ 60 , '*', 'auto', 'auto', 'auto', 80, 50 ],
      data: data
    };
    this.gtp.exportPdf(pdfData, `control_velocidades`);
    this.loadingPdf = false;
  }

  exportXls() {
    this.loadingXls = true;
    var fecha = `${this.filter.desde} - Hasta: ${this.filter.hasta}`;
    //Agregar Header
    var columns: any = [
        'Cod. Equipo',
        'Descripción',
        'Fecha',
        'Hora',
        'Dirección',
        'Velocidad'
    ];
      var data = [];
      //Carga Registros
      this.dataSource.data.forEach((e,i) => {
        if(e.mensajes.count!=0){
          if(e.mensajes.count==0) { return; }
          e.mensajes.list.forEach((item,k) => {
            data.push([
              e.cod_equipo_rastreo,
              e.equipoRastreo.des_equipo_ratreo,
              this.gtp.getDay(item.fecha_hora),
              this.gtp.getHour(item.fecha_hora),
              item.direccion.formateada,
              item.velocidad+' Km/h'              
            ]);
          });
        }
      });
      this.gtp.exportExcel('CONTROL DE VELOCIDADES', fecha, columns, data, `control_velocidades`);
      this.loadingXls = false;    
  }

}
